import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { NavDropdown, Nav, Navbar } from 'react-bootstrap';
import { withTranslation, WithTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { AppState } from '../store/state/app.state';
import { connect } from 'react-redux';
import { User } from '../store/state/user.state';
import { IMenu } from '../models/login';
import Scrollbar from 'react-scrollbars-custom';
import { ISidebarState } from '../fleet-portal/types/stateTypes';

interface ISidebarProps {
    location: any;
    history: any;
    userData: User;
    t: TFunction;
}
class Sidebar extends React.Component<ISidebarProps & WithTranslation, ISidebarState> {
    scrollRef: any = React.createRef();

    constructor(props) {
        super(props);
        this.state = { currentOpenMenu: '/', navItems: [], anotherMenuOpened: false };
    }

    UNSAFE_componentWillMount() {
        this.setState({ currentOpenMenu: this.props.location.pathname });
    }

    componentDidMount() {
        const { userData } = this.props;
        if (userData && userData.menus) {
            this.generateMenuData(userData.menus);
        }
    }

    componentDidUpdate(): void {
        if (!this.state.anotherMenuOpened) {
            const activeNavElement = document.querySelectorAll('.dropdown-item.active');

            let activeNavELementPosition =
                activeNavElement && activeNavElement.length ? activeNavElement[0].getBoundingClientRect() : null;
            let scrollYPosition = activeNavELementPosition ? activeNavELementPosition.top : 0;
            if (scrollYPosition > 580) {
                this.scrollRef.current.scrollTo(0, scrollYPosition);
            }
        }
    }

    UNSAFE_componentWillReceiveProps(props: ISidebarProps & WithTranslation) {
        if (props.userData && props.userData.menus && props.userData.menus !== this.props.userData.menus) {
            this.generateMenuData(props.userData.menus);
        }
    }

    generateMenuData = (menus: IMenu[]) => {
        let navItems = menus
            .filter((item) => item.shows_in_menu === true)
            .map(({ name, image, subMenus, url, display_order, pageOptions }) => {
                let eImage = '';
                let displayAsMenu = false;
                try {
                    eImage = require(`../assets/images/${image}`);
                } catch (e) {
                    console.error(e);
                }
                const menuItem: any = {
                    to: url || name,
                    name: name,
                    exact: true,
                    Icon: image && eImage,
                    display_order,
                    meta: { title: name },
                    pageOptions,
                };
                if (pageOptions === null && subMenus && _.isEmpty(subMenus)) {
                    return null;
                }
                if (subMenus && subMenus.length) {
                    const menu = subMenus.map(({ name, url, pageOptions, display_order, shows_in_menu }) => {
                        if (pageOptions === null) return null;
                        else if (pageOptions !== null && !shows_in_menu) {
                            displayAsMenu = true;
                            return null;
                        }
                        return {
                            to: url || '/',
                            name: name,
                            exact: true,
                            meta: { title: name },
                            display_order,
                            pageOptions: pageOptions,
                        };
                    });
                    Object.assign(menuItem, {
                        itmes: _.sortBy(
                            menu.filter((item) => item !== null),
                            ['display_order'],
                        ),
                    });
                }
                if (menuItem.pageOptions === null && _.isEmpty(menuItem.itmes) && !displayAsMenu) {
                    return null;
                }
                return menuItem;
            });
        if (navItems) {
            navItems = _.sortBy(
                navItems.filter((item) => item !== null),
                ['display_order'],
            );
        }
        this.setState({
            ...this.state,
            navItems,
        });
    };

    remove = () => {
        if (window.innerWidth <= 767) {
            document.body.classList.remove('menu-open-mobile');
        }
    };
    isActive = (url: string): boolean => url === this.props.location.pathname;
    isDefaultShow = (url: string): boolean => this.state.currentOpenMenu.indexOf(url) !== -1;
    toggleMenuShow = (url: string) => {
        if (this.state.currentOpenMenu.indexOf(url) !== -1) {
            this.setState({ currentOpenMenu: '/' });
        } else {
            this.setState({ currentOpenMenu: url, anotherMenuOpened: true });
        }
    };

    render() {
        return (
            <div>
                <div className="main-navigation">
                    <Scrollbar ref={this.scrollRef}>
                        <Navbar collapseOnSelect variant="dark">
                            <Navbar.Collapse>
                                <Nav className="mr-auto">
                                    {this.state.navItems &&
                                        this.state.navItems.map(({ to, name, Icon, meta, itmes }, index) => {
                                            if (itmes && itmes.length > 0) {
                                                let activeItem = itmes.find((item) => this.isActive(item.to));
                                                let defaultOpenedMenu = false;
                                                if (activeItem) {
                                                    defaultOpenedMenu = true;
                                                }
                                                return (
                                                    <NavDropdown
                                                        key={`menu-${index}`}
                                                        title={
                                                            <div onClick={() => this.toggleMenuShow(to)}>
                                                                {' '}
                                                                {Icon && (
                                                                    <img className="icon" src={Icon} alt={meta.title} />
                                                                )}
                                                                {name}
                                                            </div>
                                                        }
                                                        id={`menu-${index}`}
                                                        show={
                                                            this.state.currentOpenMenu === to ||
                                                            (defaultOpenedMenu && !this.state.anotherMenuOpened)
                                                        }
                                                        onClick={(e) => {
                                                            if (
                                                                !(e.target as any).className
                                                                    ?.split(' ')
                                                                    .includes('dropdown-item')
                                                            ) {
                                                                this.toggleMenuShow(to);
                                                            }
                                                        }}
                                                    >
                                                        {itmes.map((item, index) => (
                                                            <NavDropdown.Item
                                                                key={`submenu-${index}`}
                                                                as={Link}
                                                                to={item.to}
                                                                onClick={this.remove}
                                                                active={this.isActive(item.to)}
                                                            >
                                                                {item.name}{' '}
                                                            </NavDropdown.Item>
                                                        ))}
                                                    </NavDropdown>
                                                );
                                            }
                                            return (
                                                <Nav.Link
                                                    key={`menu-${index}`}
                                                    as={Link}
                                                    to={to}
                                                    onClick={() => {
                                                        this.remove();
                                                        this.setState({ currentOpenMenu: to });
                                                    }}
                                                    active={this.isActive(to)}
                                                >
                                                    {Icon && <img className="icon" src={Icon} alt={meta.title} />}
                                                    {name}
                                                </Nav.Link>
                                            );
                                        })}
                                </Nav>
                            </Navbar.Collapse>
                        </Navbar>
                    </Scrollbar>
                </div>
                <div className="menu-overlay" onClick={this.remove}></div>
            </div>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    userData: state.UserData,
});

export default connect(mapStateToProps, null)(withTranslation()(Sidebar));
